import { OptionI } from "utils/interface";

export type ThemeVariant = "light" | "dark" | "auto";
export type NavPositionVariant = "horizontal" | "vertical" | "combo" | "dual";
export type NavTopShapeVariant = "default" | "slim";
export type NavbarAppearanceVariant = "default" | "darker";
export interface Config {
  isNavbarVerticalCollapsed: boolean;
  openNavbarVertical: boolean;
  theme: ThemeVariant;
  navbarVerticalAppearance: NavbarAppearanceVariant;
  navbarTopAppearance: NavbarAppearanceVariant;
  navbarPosition: NavPositionVariant;
  navbarTopShape: NavTopShapeVariant;
  isRTL: boolean;
  isDark: boolean;
  bodyClass?: string;
  isChatWidgetVisible: boolean;
}

export const initialConfig: Config = {
  isNavbarVerticalCollapsed: false,
  openNavbarVertical: false, // for responsive
  theme: "light",
  navbarTopAppearance: "default",
  navbarVerticalAppearance: "default",
  navbarPosition: "vertical",
  navbarTopShape: "default",
  isRTL: false,
  isDark: false,
  isChatWidgetVisible: true,
};

export const config = {
  pageLimit: 10,
};
export const variables = {
  SELL: "SELL",
  FLOOR_NUMBER: "floor_number",
};

export const PROPERTY_LISTING_STATUS: OptionI[] = [
  {
    label: "Pending",
    value: "PENDING",
  },
  {
    label: "Approve",
    value: "APPROVED",
  },
  {
    label: "Reject",
    value: "REJECTED",
  },
];

export const USER_ENQUIRY_LISTING_STATUS: OptionI[] = [
  {
    label: "Pending",
    value: "PENDING",
  },
  {
    label: "Closed",
    value: "APPROVED",
  },
  {
    label: "On Hold",
    value: "ONHOLD-ADMIN",
  },
];
export const BLOGS_STATUS: OptionI[] = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  },
];
export const constructionOptions: OptionI[] = [
  {
    label: "Pre-launch",
    value: "pre_launch",
  },
  {
    label: "Under Construction",
    value: "under_construction",
  },
  {
    label: "Ready to move",
    value: "ready_to_move",
  },
];
export const minValue: { label: string; value: number }[] = [
  { label: "₹ 5 Lac", value: 500000 },
  { label: "₹ 10 Lac", value: 1000000 },
  { label: "₹ 15 Lac", value: 1500000 },
  { label: "₹ 20 Lac", value: 2000000 },
  { label: "₹ 25 Lac", value: 2500000 },
  { label: "₹ 30 Lac", value: 3000000 },
  { label: "₹ 35 Lac", value: 3500000 },
  { label: "₹ 40 Lac", value: 4000000 },
  { label: "₹ 45 Lac", value: 4500000 },
  { label: "₹ 50 Lac", value: 5000000 },
  { label: "₹ 60 Lac", value: 6000000 },
  { label: "₹ 70 Lac", value: 7000000 },
  { label: "₹ 80 Lac", value: 8000000 },
  { label: "₹ 90 Lac", value: 9000000 },
  { label: "₹ 1 Cr", value: 10000000 },
  { label: "₹ 1.2 Cr", value: 12000000 },
  { label: "₹ 1.4 Cr", value: 14000000 },
  { label: "₹ 1.6 Cr", value: 16000000 },
  { label: "₹ 1.8 Cr", value: 18000000 },
  { label: "₹ 2.0 Cr", value: 20000000 },
  { label: "₹ 2.3 Cr", value: 23000000 },
  { label: "₹ 2.6 Cr", value: 26000000 },
  { label: "₹ 3 Cr", value: 30000000 },
  { label: "₹ 3.5 Cr", value: 35000000 },
  { label: "₹ 4 Cr", value: 40000000 },
  { label: "₹ 4.5 Cr", value: 45000000 },
  { label: "₹ 5 Cr", value: 50000000 },
  { label: "₹ 10 Cr", value: 100000000 },
  { label: "₹ 15 Cr", value: 150000000 },
  { label: "₹ 20 Cr", value: 200000000 },
  { label: "₹ 25 Cr", value: 250000000 },
  { label: "₹ 30 Cr", value: 300000000 },
  { label: "₹ 35 Cr", value: 350000000 },
  { label: "₹ 40 Cr", value: 400000000 },
  { label: "₹ 45 Cr", value: 450000000 },
  { label: "₹ 50 Cr", value: 500000000 },
];

export const maxValue: { label: string; value: number }[] = [
  { label: "₹ 10 Lac", value: 1000000 },
  { label: "₹ 15 Lac", value: 1500000 },
  { label: "₹ 20 Lac", value: 2000000 },
  { label: "₹ 25 Lac", value: 2500000 },
  { label: "₹ 30 Lac", value: 3000000 },
  { label: "₹ 35 Lac", value: 3500000 },
  { label: "₹ 40 Lac", value: 4000000 },
  { label: "₹ 45 Lac", value: 4500000 },
  { label: "₹ 50 Lac", value: 5000000 },
  { label: "₹ 60 Lac", value: 6000000 },
  { label: "₹ 70 Lac", value: 7000000 },
  { label: "₹ 80 Lac", value: 8000000 },
  { label: "₹ 90 Lac", value: 9000000 },
  { label: "₹ 1 Cr", value: 10000000 },
  { label: "₹ 1.2 Cr", value: 12000000 },
  { label: "₹ 1.4 Cr", value: 14000000 },
  { label: "₹ 1.6 Cr", value: 16000000 },
  { label: "₹ 1.8 Cr", value: 18000000 },
  { label: "₹ 2.0 Cr", value: 20000000 },
  { label: "₹ 2.3 Cr", value: 23000000 },
  { label: "₹ 2.6 Cr", value: 26000000 },
  { label: "₹ 3 Cr", value: 30000000 },
  { label: "₹ 3.5 Cr", value: 35000000 },
  { label: "₹ 4 Cr", value: 40000000 },
  { label: "₹ 4.5 Cr", value: 45000000 },
  { label: "₹ 5 Cr+", value: 50000000 },
  { label: "₹ 10 Cr", value: 100000000 },
  { label: "₹ 15 Cr", value: 150000000 },
  { label: "₹ 20 Cr", value: 200000000 },
  { label: "₹ 25 Cr", value: 250000000 },
  { label: "₹ 30 Cr", value: 300000000 },
  { label: "₹ 35 Cr", value: 350000000 },
  { label: "₹ 40 Cr", value: 400000000 },
  { label: "₹ 45 Cr", value: 450000000 },
  { label: "₹ 50 Cr", value: 500000000 },
];

export const CREATED_AT_OPTIONS: OptionI[] = [
  {
    label: "Today",
    value: "TODAY",
  },
  {
    label: "Last Seven days",
    value: "LAST_SEVEN_DAYS",
  },
  {
    label: "Last 30 days",
    value: "LAST_30_DAYS",
  },
];

export const CITY_OPTIONS: OptionI[] = [
  {
    label: "Ahmedabad",
    value: "Ahmedabad",
  },
  {
    label: "Gandhinagar",
    value: "Gandhinagar",
  },
];
export const LISTING_TYPE_OPTIONS: OptionI[] = [
  {
    label: "SELL",
    value: "SELL",
  },
  {
    label: "RENT",
    value: "RENT",
  },
];

export const LINKED_PROJECT_OPTIONS: OptionI[] = [
  {
    label: "Projects Linked",
    value: "true",
  },
  {
    label: "Not Linked",
    value: "false",
  },
  {
    label: "Both",
    value: "both",
  },
];
export const NOTIFICATION_STATUS: any = [
  {
    label: "ENABLED",
    value: true,
  },
  {
    label: "DISABLED",
    value: false,
  },
];

export const ENQUIRY_TYPES: OptionI[] = [
  {
    label: "Advertise",
    value: "advertise_your_property_inquiry",
  },
  {
    label: "Become Partner",
    value: "become_partner_inquiry",
  },
  {
    label: "Builder",
    value: "builder_inquiry",
  },
  {
    label: "Home Loan",
    value: "home_loan",
  },
  {
    label: "Contact Us",
    value: "contact_us",
  },

  {
    label: "User Feedback",
    value: "user_feedback",
  },
];
export const ACCEPTABLEFILE = ".jpg, .jpeg, .png, .heic, .mp4";

export const PROPERTY_ISSUE_TYPE: OptionI[] = [
  {
    label: "Suspicious, Spam or Fake",
    value: "spam_fake",
  },
  {
    label: "Harassment or Hateful Speech",
    value: "harassment_hate",
  },
  {
    label: "Violence or Physical Harm",
    value: "violence_harm",
  },
  {
    label: "Adult Content",
    value: "adult_content",
  },
  {
    label: "Intellectual Property Violations",
    value: "ip_violation",
  },
  {
    label: "Others",
    value: "others",
  },
];
export const slugOrder = [
  "carpet_area_number",
  "carpet_area_type",
  "super_area_number",
  "super_area_type",
  "plot_area_number",
  "plot_area_type",
];
export const inputTypes = [
  "METRIC_SYSTEM",
  "NUMBER",
  "RANGE",
  "YEAR_SELECT",
  "PERCENTAGE",
];

export const uiInputTypes: any = {
  STRING: { type: "STRING", columnStructure: "col-sm-12 col-lg-6" },
  DROPDOWN: { type: "DROPDOWN", columnStructure: "col-sm-12 col-lg-6" },
  NUMBER: { type: "NUMBER", columnStructure: "col-sm-12 col-lg-6" },
  PERCENTAGE: { type: "PERCENTAGE", columnStructure: "col-sm-12 col-lg-6" },
  TEXT_AREA: { type: "TEXT_AREA", columnStructure: "col-sm-12 col-lg-12" },
  DATETIME: { type: "DATETIME", columnStructure: "col-sm-12 col-lg-3" },
  MULTISELECT: { type: "MULTISELECT", columnStructure: "col-sm-12 col-lg-3" },
  CHECKBOX: {
    type: "CHECKBOX",
    columnStructure: "col-sm-12 col-lg-6",
  },
  CHECKBOXGROUP: {
    type: "CHECKBOXGROUP",
    columnStructure: "col-sm-12 col-md-12 col-lg-12",
  },
  /// new data added
  RANGE: {
    type: "RANGE",
    columnStructure: "col-sm-12 col-md-12 col-lg-12",
  },
  MULTI_SELECT_RANGE: {
    type: "MULTI_SELECT_RANGE",
    columnStructure: "col-sm-12 col-md-12 col-lg-12",
  },
  SINGLE_SELECT: {
    type: "SINGLE_SELECT",
    columnStructure: "col-sm-12 col-md-12 col-lg-12",
  },
  MULTI_SELECT: {
    type: "MULTI_SELECT",
    columnStructure: "col-12 col-md-12 col-lg-12",
  },
  METRIC_SYSTEM: {
    type: "METRIC_SYSTEM",
    columnStructure: "col-sm-6 col-md-6 col-lg-6",
  },
  MONTHYEAR: {
    type: "MONTHYEAR",
    columnStructure: "col-sm-12 col-md-6 col-lg-6",
  },
  YEARSELECT: {
    type: "YEARSELECT",
    columnStructure: "col-sm-12 col-md-6 col-lg-6",
  },
  FILE_UPLOAD: {
    type: "FILE_UPLOAD",
    columnStructure: "col-sm-12 col-md-6 col-lg-12",
  },
  DATE: {
    type: "DATE",
    columnStructure: "col-sm-12 col-md-6 col-lg-6",
  },
  TIME: {
    type: "TIME",
    columnStructure: "col-sm-12 col-md-6 col-lg-6",
  },
};

const areaTypes = [
  {
    option_label: "Sq-ft",
    option_value: "sq_ft",
  },
  {
    option_label: "Sq-km",
    option_value: "sq_km",
  },
  {
    option_label: "Sq-m",
    option_value: "sq_m",
  },
  {
    option_label: "Sq-yd",
    option_value: "sq_yd",
  },
];

export const staticFields: any = [
  {
    name: "Total floors",
    required: false,
    slug: "total_floors",
    type: "RANGE",
    min: 0,
    max: 45,
  },
  {
    name: "Construction status",
    required: false,
    slug: "construction_status",
    type: "DROPDOWN",
    options: [
      {
        option_label: "Pre-launch",
        option_value: "pre_launch",
      },
      {
        option_label: "Under Construction",
        option_value: "under_construction",
      },
      {
        option_label: "Ready to move",
        option_value: "ready_to_move",
      },
    ],
  },
  {
    name: "Possession date",
    required: false,
    slug: "possession_date",
    type: "MONTHYEAR",
    forward: true,
  },
  {
    name: "Age of construction",
    required: false,
    slug: "construction_age",
    type: "DROPDOWN",
    options: [
      {
        option_label: "<1",
        option_value: "less_than_1",
      },
      {
        option_label: "1 to 2",
        option_value: "1_to_2",
      },
      {
        option_label: "2 to 3",
        option_value: "2_to_3",
      },
      {
        option_label: "3 to 5",
        option_value: "3_to_5",
      },
      {
        option_label: ">5",
        option_value: "greater_than_5",
      },
    ],
  },
  {

    name: "Is Project Partner",
    required: false,
    slug: "is_project_partner",
    type: "CHECKBOX",
 
  },
  {
    name: "Amenities",
    required: false,
    slug: "amenities",
    type: "MULTI_SELECT",
    options: [
      {
        option_label: "Lift",
        option_value: "lift",
      },
      {
        option_label: "CCTV",
        option_value: "cctv",
      },
      {
        option_label: "GYM",
        option_value: "gym",
      },
      {
        option_label: "Garden/ Park",
        option_value: "garden_park",
      },
      {
        option_label: "Kids Play Area",
        option_value: "kids_play_area",
      },
      {
        option_label: "Sports Club",
        option_value: "sports_club",
      },
      {
        option_label: "Cricket Pitch",
        option_value: "cricket_pitch",
      },
      {
        option_label: "Basket Ball court",
        option_value: "basket_ball_court",
      },
      {
        option_label: "Scatting",
        option_value: "scatting",
      },
      {
        option_label: "Swimming Pool",
        option_value: "swimming_pool",
      },
      {
        option_label: "Intercom",
        option_value: "intercom",
      },
      {
        option_label: "Gated Community",
        option_value: "gated_community",
      },
      {
        option_label: "Security",
        option_value: "security",
      },
      {
        option_label: "Club House",
        option_value: "club_house",
      },
      {
        option_label: "Community Hall",
        option_value: "community_hall",
      },
      {
        option_label: "Regular Water Supply",
        option_value: "regular_water_supply",
      },
      {
        option_label: "Generator",
        option_value: "generator",
      },
      {
        option_label: "Indoor Games",
        option_value: "indoor_games",
      },
      {
        option_label: "Power Backup",
        option_value: "power_backup",
      },
      {
        option_label: "Pet Allowed",
        option_value: "pet_allowed",
      },
      {
        option_label: "No Vehicle Zone",
        option_value: "no_vehicle_zone",
      },
      {
        option_label: "Gazebo",
        option_value: "gazebo",
      },
      {
        option_label: "Reserved Parking",
        option_value: "reserved_parking",
      },
      {
        option_label: "Piped Gas",
        option_value: "piped_gas",
      },
      {
        option_label: "Vaastu Compliant",
        option_value: "vaastu_compliant",
      },
      {
        option_label: "Mini Theatre",
        option_value: "mini_theatre",
      },
      {
        option_label: "Solar Roof",
        option_value: "solar_roof",
      },
    ],
  },
  {
    name: "Rera number",
    required: false,
    slug: "rera_number",
    type: "STRING",
  },

  {
    name: "Total units",
    required: false,
    slug: "total_units",
    type: "NUMBER",
  },
  {
    name: "Total blocks",
    required: false,
    slug: "total_blocks",
    type: "NUMBER",
  },
  {
    name: "Launch date",
    required: false,
    slug: "launch_date",
    type: "DATE",
  },
  {
    name: "Developer name",
    required: false,
    slug: "developer_id",
    type: "DROPDOWN",
  },
  {
    name: "Property Transaction",
    required: false,
    slug: "property_transaction",
    type: "DROPDOWN",
    options: [
      {
        option_label: "New",
        option_value: "new",
      },
      {
        option_label: "Resale",
        option_value: "resale",
      },
    ],
  },
  {
    name: "Project area number",
    required: false,
    slug: "project_area_number",
    type: "METRIC_SYSTEM",
    section: {
      section_name: "Project Area number",
      section_slug: "project_area",
    },
  },
  {
    name: "Project area type",
    required: false,
    slug: "project_area_type",
    type: "DROPDOWN",
    section: {
      section_name: "Project Area type",
      section_slug: "project_area",
    },
    options: areaTypes,
  },
  {
    name: "Brochure",
    required: false,
    slug: "brochure",
    type: "FILE_UPLOAD",
  },
];

export const defaultData: string[] = [
  "flat-apartment",
  "bunglow-villa",
  "weekend-homes",
  "penthouse",
  "farm-house",
  "duplex"
];

export const updatedDataForDynamicFields: any = {
  Residential: {
    "flat-apartment": {
      singleField: {
        bathrooms: null,
        balcony: null,
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        asking_price: null,
      },
    },
    "bunglow-villa": {
      singleField: {
        bathrooms: null,
        balcony: null,
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        plot_length_number: null,
        plot_length_type: null,
        plot_breadth_number: null,
        plot_breadth_type: null,
        plot_area_number: null,
        plot_area_type: null,
        asking_price: null,
      },
    },
    "studio-apartment": {
      singleField: {
        bathrooms: null,
        balcony: null,
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        asking_price: null,
      },
    },
    "weekend-homes": {
      singleField: {
        bathrooms: null,
        balcony: null,
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        plot_length_number: null,
        plot_length_type: null,
        plot_breadth_number: null,
        plot_breadth_type: null,
        plot_area_number: null,
        plot_area_type: null,
        asking_price: null,
      },
    },
    "farm-house": {
      singleField: {
        bathrooms: null,
        balcony: null,
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        plot_length_number: null,
        plot_length_type: null,
        plot_breadth_number: null,
        plot_breadth_type: null,
        plot_area_number: null,
        plot_area_type: null,
        asking_price: null,
      },
    },
    penthouse: {
      singleField: {
        bathrooms: null,
        balcony: null,
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        asking_price: null,
      },
    },
   duplex: {
      singleField: {
        bathrooms: null,
        balcony: null,
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        asking_price: null,
      },
    },
  },
  Commercial: {
    shop: {
      singleField: {
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        asking_price: null,
      },
    },
    office: {
      singleField: {
        balcony: null,
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        asking_price: null,
      },
    },
    warehousegodown: {
      singleField: {
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        plot_area_number: null,
        plot_area_type: null,
        plot_length_number: null,
        plot_length_type: null,
        plot_breadth_number: null,
        plot_breadth_type: null,
        asking_price: null,
      },
    },
    showroom: {
      singleField: {
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        asking_price: null,
      },
    },
    "cold-storage": {
      singleField: {
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        plot_area_number: null,
        plot_area_type: null,
        plot_length_number: null,
        plot_length_type: null,
        plot_breadth_number: null,
        plot_breadth_type: null,
        asking_price: null,
      },
    },
    "industrial-shed": {
      singleField: {
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        plot_area_number: null,
        plot_area_type: null,
        plot_length_number: null,
        plot_length_type: null,
        plot_breadth_number: null,
        plot_breadth_type: null,
        asking_price: null,
      },
    },
    hotelresort: {
      singleField: {
        balcony: null,
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        plot_area_number: null,
        plot_area_type: null,
        plot_length_number: null,
        plot_length_type: null,
        plot_breadth_number: null,
        plot_breadth_type: null,
        asking_price: null,
      },
    },
    "guest-house": {
      singleField: {
        balcony: null,
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        plot_area_number: null,
        plot_area_type: null,
        plot_length_number: null,
        plot_length_type: null,
        plot_breadth_number: null,
        plot_breadth_type: null,
        asking_price: null,
      },
    },
    "co-working-space-business-centrespace": {
      singleField: {
        car_parking: null,
      },
      variant: {
        super_area_number: null,
        super_area_type: null,
        floor_plan: null,
        asking_price: null,
      },
    },
  },
  Plot: {
    "residential-plot": {
      singleField: {
        car_parking: null,
      },
      variant: {
        // super_area_number: null,
        // super_area_type: null,
        floor_plan: null,
        plot_area_number: null,
        plot_area_type: null,
        plot_length_number: null,
        plot_length_type: null,
        plot_breadth_number: null,
        plot_breadth_type: null,
        asking_price: null,
      },
    },
    "industrial-plot": {
      singleField: {
        car_parking: null,
      },
      variant: {
        // super_area_number: null,
        // super_area_type: null,
        floor_plan: null,
        plot_area_number: null,
        plot_area_type: null,
        plot_length_number: null,
        plot_length_type: null,
        plot_breadth_number: null,
        plot_breadth_type: null,
        asking_price: null,
      },
    },
    "commercial-plot": {
      singleField: {
        car_parking: null,
      },
      variant: {
        // super_area_number: null,
        // super_area_type: null,
        floor_plan: null,
        plot_area_number: null,
        plot_area_type: null,
        plot_length_number: null,
        plot_length_type: null,
        plot_breadth_number: null,
        plot_breadth_type: null,
        asking_price: null,
      },
    },
  },
};

export const updatedSlugWithInputType: any = {
  Residential: {
    "flat-apartment": {
      singleField: [
        {
          slug: "bathrooms",
          name: "Bathrooms",
          type: "RANGE",
          min: 0,
          max: 35,
        },
        { name: "Balcony", slug: "balcony", type: "RANGE", min: 0, max: 35 },
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Carpet area number",
          required: false,
          slug: "carpet_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Carpet area number",
            section_slug: "carpet_area",
          },
          canMultiple: true,
        },
        {
          name: "Carpet area type",
          required: false,
          slug: "carpet_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Carpet Area type",
            section_slug: "carpet_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    "bunglow-villa": {
      singleField: [
        {
          slug: "bathrooms",
          name: "Bathrooms",
          type: "RANGE",
          min: 0,
          max: 35,
        },
        { name: "Balcony", slug: "balcony", type: "RANGE", min: 0, max: 35 },
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot length number",
          required: false,
          slug: "plot_length_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot length number",
            section_slug: "plot_length",
          },
          canMultiple: true,
        },
        {
          name: "Plot length type",
          required: false,
          slug: "plot_length_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot length type",
            section_slug: "plot_length",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot breadth number",
          required: false,
          slug: "plot_breadth_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot breadth number",
            section_slug: "plot_breadth",
          },
          canMultiple: true,
        },
        {
          name: "Plot breadth type",
          required: false,
          slug: "plot_breadth_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot breadth type",
            section_slug: "plot_breadth",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot area number",
          required: false,
          slug: "plot_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot area number",
            section_slug: "plot_area",
          },
          canMultiple: true,
        },
        {
          name: "Plot area type",
          required: false,
          slug: "plot_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot Area type",
            section_slug: "plot_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    "studio-apartment": {
      singleField: [
        {
          slug: "bathrooms",
          name: "Bathrooms",
          type: "RANGE",
          min: 0,
          max: 35,
        },
        { name: "Balcony", slug: "balcony", type: "RANGE", min: 0, max: 35 },
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },

        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    "weekend-homes": {
      singleField: [
        {
          slug: "bathrooms",
          name: "Bathrooms",
          type: "RANGE",
          min: 0,
          max: 35,
        },
        { name: "Balcony", slug: "balcony", type: "RANGE", min: 0, max: 35 },
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot length number",
          required: false,
          slug: "plot_length_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot length number",
            section_slug: "plot_length",
          },
          canMultiple: true,
        },
        {
          name: "Plot length type",
          required: false,
          slug: "plot_length_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot length type",
            section_slug: "plot_length",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot breadth number",
          required: false,
          slug: "plot_breadth_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot breadth number",
            section_slug: "plot_breadth",
          },
          canMultiple: true,
        },
        {
          name: "Plot breadth type",
          required: false,
          slug: "plot_breadth_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot breadth type",
            section_slug: "plot_breadth",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot area number",
          required: false,
          slug: "plot_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot area number",
            section_slug: "plot_area",
          },
          canMultiple: true,
        },
        {
          name: "Plot area type",
          required: false,
          slug: "plot_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot Area type",
            section_slug: "plot_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    "farm-house": {
      singleField: [
        {
          slug: "bathrooms",
          name: "Bathrooms",
          type: "RANGE",
          min: 0,
          max: 35,
        },
        { name: "Balcony", slug: "balcony", type: "RANGE", min: 0, max: 35 },
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot length number",
          required: false,
          slug: "plot_length_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot length number",
            section_slug: "plot_length",
          },
          canMultiple: true,
        },
        {
          name: "Plot length type",
          required: false,
          slug: "plot_length_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot length type",
            section_slug: "plot_length",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot breadth number",
          required: false,
          slug: "plot_breadth_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot breadth number",
            section_slug: "plot_breadth",
          },
          canMultiple: true,
        },
        {
          name: "Plot breadth type",
          required: false,
          slug: "plot_breadth_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot breadth type",
            section_slug: "plot_breadth",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot area number",
          required: false,
          slug: "plot_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot area number",
            section_slug: "plot_area",
          },
          canMultiple: true,
        },
        {
          name: "Plot area type",
          required: false,
          slug: "plot_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot Area type",
            section_slug: "plot_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    penthouse: {
      singleField: [
        {
          slug: "bathrooms",
          name: "Bathrooms",
          type: "RANGE",
          min: 0,
          max: 35,
        },
        { name: "Balcony", slug: "balcony", type: "RANGE", min: 0, max: 35 },
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },

        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    duplex: {
      singleField: [
        {
          slug: "bathrooms",
          name: "Bathrooms",
          type: "RANGE",
          min: 0,
          max: 35,
        },
        { name: "Balcony", slug: "balcony", type: "RANGE", min: 0, max: 35 },
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Carpet area number",
          required: false,
          slug: "carpet_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Carpet area number",
            section_slug: "carpet_area",
          },
          canMultiple: true,
        },
        {
          name: "Carpet area type",
          required: false,
          slug: "carpet_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Carpet Area type",
            section_slug: "carpet_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
  },

  Commercial: {
    shop: {
      singleField: [
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },

        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    office: {
      singleField: [
        { name: "Balcony", slug: "balcony", type: "RANGE", min: 0, max: 35 },
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },

        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    warehousegodown: {
      singleField: [
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot length number",
          required: false,
          slug: "plot_length_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot length number",
            section_slug: "plot_length",
          },
          canMultiple: true,
        },
        {
          name: "Plot length type",
          required: false,
          slug: "plot_length_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot length type",
            section_slug: "plot_length",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot breadth number",
          required: false,
          slug: "plot_breadth_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot breadth number",
            section_slug: "plot_breadth",
          },
          canMultiple: true,
        },
        {
          name: "Plot breadth type",
          required: false,
          slug: "plot_breadth_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot breadth type",
            section_slug: "plot_breadth",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot area number",
          required: false,
          slug: "plot_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot area number",
            section_slug: "plot_area",
          },
          canMultiple: true,
        },
        {
          name: "Plot area type",
          required: false,
          slug: "plot_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot Area type",
            section_slug: "plot_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    showroom: {
      singleField: [
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },

        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    "cold-storage": {
      singleField: [
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot length number",
          required: false,
          slug: "plot_length_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot length number",
            section_slug: "plot_length",
          },
          canMultiple: true,
        },
        {
          name: "Plot length type",
          required: false,
          slug: "plot_length_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot length type",
            section_slug: "plot_length",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot breadth number",
          required: false,
          slug: "plot_breadth_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot breadth number",
            section_slug: "plot_breadth",
          },
          canMultiple: true,
        },
        {
          name: "Plot breadth type",
          required: false,
          slug: "plot_breadth_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot breadth type",
            section_slug: "plot_breadth",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot area number",
          required: false,
          slug: "plot_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot area number",
            section_slug: "plot_area",
          },
          canMultiple: true,
        },
        {
          name: "Plot area type",
          required: false,
          slug: "plot_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot Area type",
            section_slug: "plot_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    "industrial-shed": {
      singleField: [
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot length number",
          required: false,
          slug: "plot_length_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot length number",
            section_slug: "plot_length",
          },
          canMultiple: true,
        },
        {
          name: "Plot length type",
          required: false,
          slug: "plot_length_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot length type",
            section_slug: "plot_length",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot breadth number",
          required: false,
          slug: "plot_breadth_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot breadth number",
            section_slug: "plot_breadth",
          },
          canMultiple: true,
        },
        {
          name: "Plot breadth type",
          required: false,
          slug: "plot_breadth_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot breadth type",
            section_slug: "plot_breadth",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot area number",
          required: false,
          slug: "plot_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot area number",
            section_slug: "plot_area",
          },
          canMultiple: true,
        },
        {
          name: "Plot area type",
          required: false,
          slug: "plot_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot Area type",
            section_slug: "plot_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    hotelresort: {
      singleField: [
        { name: "Balcony", slug: "balcony", type: "RANGE", min: 0, max: 35 },
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot length number",
          required: false,
          slug: "plot_length_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot length number",
            section_slug: "plot_length",
          },
          canMultiple: true,
        },
        {
          name: "Plot length type",
          required: false,
          slug: "plot_length_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot length type",
            section_slug: "plot_length",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot breadth number",
          required: false,
          slug: "plot_breadth_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot breadth number",
            section_slug: "plot_breadth",
          },
          canMultiple: true,
        },
        {
          name: "Plot breadth type",
          required: false,
          slug: "plot_breadth_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot breadth type",
            section_slug: "plot_breadth",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot area number",
          required: false,
          slug: "plot_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot area number",
            section_slug: "plot_area",
          },
          canMultiple: true,
        },
        {
          name: "Plot area type",
          required: false,
          slug: "plot_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot Area type",
            section_slug: "plot_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    "guest-house": {
      singleField: [
        { name: "Balcony", slug: "balcony", type: "RANGE", min: 0, max: 35 },
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot length number",
          required: false,
          slug: "plot_length_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot length number",
            section_slug: "plot_length",
          },
          canMultiple: true,
        },
        {
          name: "Plot length type",
          required: false,
          slug: "plot_length_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot length type",
            section_slug: "plot_length",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot breadth number",
          required: false,
          slug: "plot_breadth_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot breadth number",
            section_slug: "plot_breadth",
          },
          canMultiple: true,
        },
        {
          name: "Plot breadth type",
          required: false,
          slug: "plot_breadth_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot breadth type",
            section_slug: "plot_breadth",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot area number",
          required: false,
          slug: "plot_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot area number",
            section_slug: "plot_area",
          },
          canMultiple: true,
        },
        {
          name: "Plot area type",
          required: false,
          slug: "plot_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot Area type",
            section_slug: "plot_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    "co-working-space-business-centrespace": {
      singleField: [
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        {
          name: "Super area number",
          required: false,
          slug: "super_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Super area number",
            section_slug: "super_area",
          },
          canMultiple: true,
        },
        {
          name: "Super area type",
          required: false,
          slug: "super_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Super Area type",
            section_slug: "super_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
  },
  Plot: {
    "residential-plot": {
      singleField: [
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        // {
        //   name: "Super area number",
        //   required: false,
        //   slug: "super_area_number",
        //   type: "METRIC_SYSTEM",
        //   section: {
        //     section_name: "Super area number",
        //     section_slug: "super_area",
        //   },
        //   canMultiple: true,
        // },
        // {
        //   name: "Super area type",
        //   required: false,
        //   slug: "super_area_type",
        //   type: "DROPDOWN",
        //   section: {
        //     section_name: "Super Area type",
        //     section_slug: "super_area",
        //   },
        //   options: areaTypes,
        //   canMultiple: true,
        // },
        {
          name: "Plot length number",
          required: false,
          slug: "plot_length_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot length number",
            section_slug: "plot_length",
          },
          canMultiple: true,
        },
        {
          name: "Plot length type",
          required: false,
          slug: "plot_length_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot length type",
            section_slug: "plot_length",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot breadth number",
          required: false,
          slug: "plot_breadth_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot breadth number",
            section_slug: "plot_breadth",
          },
          canMultiple: true,
        },
        {
          name: "Plot breadth type",
          required: false,
          slug: "plot_breadth_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot breadth type",
            section_slug: "plot_breadth",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot area number",
          required: false,
          slug: "plot_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot area number",
            section_slug: "plot_area",
          },
          canMultiple: true,
        },
        {
          name: "Plot area type",
          required: false,
          slug: "plot_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot Area type",
            section_slug: "plot_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    "industrial-plot": {
      singleField: [
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        // {
        //   name: "Super area number",
        //   required: false,
        //   slug: "super_area_number",
        //   type: "METRIC_SYSTEM",
        //   section: {
        //     section_name: "Super area number",
        //     section_slug: "super_area",
        //   },
        //   canMultiple: true,
        // },
        // {
        //   name: "Super area type",
        //   required: false,
        //   slug: "super_area_type",
        //   type: "DROPDOWN",
        //   section: {
        //     section_name: "Super Area type",
        //     section_slug: "super_area",
        //   },
        //   options: areaTypes,
        //   canMultiple: true,
        // },
        {
          name: "Plot length number",
          required: false,
          slug: "plot_length_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot length number",
            section_slug: "plot_length",
          },
          canMultiple: true,
        },
        {
          name: "Plot length type",
          required: false,
          slug: "plot_length_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot length type",
            section_slug: "plot_length",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot breadth number",
          required: false,
          slug: "plot_breadth_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot breadth number",
            section_slug: "plot_breadth",
          },
          canMultiple: true,
        },
        {
          name: "Plot breadth type",
          required: false,
          slug: "plot_breadth_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot breadth type",
            section_slug: "plot_breadth",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot area number",
          required: false,
          slug: "plot_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot area number",
            section_slug: "plot_area",
          },
          canMultiple: true,
        },
        {
          name: "Plot area type",
          required: false,
          slug: "plot_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot Area type",
            section_slug: "plot_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
    "commercial-plot": {
      singleField: [
        {
          name: "Car parking",
          slug: "car_parking",
          type: "RANGE",
          min: 0,
          max: 35,
        },
      ],
      variant: [
        // {
        //   name: "Super area number",
        //   required: false,
        //   slug: "super_area_number",
        //   type: "METRIC_SYSTEM",
        //   section: {
        //     section_name: "Super area number",
        //     section_slug: "super_area",
        //   },
        //   canMultiple: true,
        // },
        // {
        //   name: "Super area type",
        //   required: false,
        //   slug: "super_area_type",
        //   type: "DROPDOWN",
        //   section: {
        //     section_name: "Super Area type",
        //     section_slug: "super_area",
        //   },
        //   options: areaTypes,
        //   canMultiple: true,
        // },
        {
          name: "Plot length number",
          required: false,
          slug: "plot_length_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot length number",
            section_slug: "plot_length",
          },
          canMultiple: true,
        },
        {
          name: "Plot length type",
          required: false,
          slug: "plot_length_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot length type",
            section_slug: "plot_length",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot breadth number",
          required: false,
          slug: "plot_breadth_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot breadth number",
            section_slug: "plot_breadth",
          },
          canMultiple: true,
        },
        {
          name: "Plot breadth type",
          required: false,
          slug: "plot_breadth_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot breadth type",
            section_slug: "plot_breadth",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Plot area number",
          required: false,
          slug: "plot_area_number",
          type: "METRIC_SYSTEM",
          section: {
            section_name: "Plot area number",
            section_slug: "plot_area",
          },
          canMultiple: true,
        },
        {
          name: "Plot area type",
          required: false,
          slug: "plot_area_type",
          type: "DROPDOWN",
          section: {
            section_name: "Plot Area type",
            section_slug: "plot_area",
          },
          options: areaTypes,
          canMultiple: true,
        },
        {
          name: "Expected price",
          required: false,
          slug: "asking_price",
          type: "NUMBER",
          canMultiple: true,
        },
        {
          name: "Upload floor plan",
          required: false,
          slug: "floor_plan",
          type: "FILE_UPLOAD",
          canMultiple: true,
        },
      ],
    },
  },
};

export const updatedDynamicFields: any = {
  Residential: {
    "flat-apartment": [
      {
        name: "Bedrooms",
        required: false,
        slug: "bedrooms",
        type: "MULTI_SELECT_RANGE",
        includes: [
          "flat-apartment",
          "bunglow-villa",
          "weekend-homes",
          "penthouse",
          "farm-house",
        ],
        min: 1,
        max: 10,
        canMultiple: false,
      },
      {
        name: "Bathrooms",
        required: false,
        slug: "bathrooms",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "balcony",
        required: false,
        slug: "balcony",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Floor plan",
        required: false,
        slug: "floor_plan",
        type: "FILE_UPLOAD",
        canMultiple: true,
      },

      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    "bunglow-villa": [
      {
        name: "Bedrooms",
        required: false,
        slug: "bedrooms",
        type: "MULTI_SELECT_RANGE",
        includes: [
          "flat-apartment",
          "bunglow-villa",
          "weekend-homes",
          "penthouse",
          "farm-house",
        ],
        min: 1,
        max: 10,
        canMultiple: false,
      },
      {
        name: "Bathrooms",
        required: false,
        slug: "bathrooms",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "balcony",
        required: false,
        slug: "balcony",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Floor plan",
        required: false,
        slug: "floor_plan",
        type: "FILE_UPLOAD",
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    "studio-apartment": [
      {
        name: "Bedrooms",
        required: false,
        slug: "bedrooms",
        type: "MULTI_SELECT_RANGE",
        includes: [
          "flat-apartment",
          "bunglow-villa",
          "weekend-homes",
          "penthouse",
          "farm-house",
        ],
        min: 1,
        max: 10,
        canMultiple: false,
      },
      {
        name: "Bathrooms",
        required: false,
        slug: "bathrooms",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "balcony",
        required: false,
        slug: "balcony",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Floor plan",
        required: false,
        slug: "floor_plan",
        type: "FILE_UPLOAD",
        canMultiple: true,
      },

      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    "weekend-homes": [
      {
        name: "Bedrooms",
        required: false,
        slug: "bedrooms",
        type: "MULTI_SELECT_RANGE",
        includes: [
          "flat-apartment",
          "bunglow-villa",
          "weekend-homes",
          "penthouse",
          "farm-house",
        ],
        min: 1,
        max: 10,
        canMultiple: false,
      },
      {
        name: "Bathrooms",
        required: false,
        slug: "bathrooms",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "balcony",
        required: false,
        slug: "balcony",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Floor plan",
        required: false,
        slug: "floor_plan",
        type: "FILE_UPLOAD",
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    "farm-house": [
      {
        name: "Bedrooms",
        required: false,
        slug: "bedrooms",
        type: "MULTI_SELECT_RANGE",
        includes: [
          "flat-apartment",
          "bunglow-villa",
          "weekend-homes",
          "penthouse",
          "farm-house",
        ],
        min: 1,
        max: 10,
        canMultiple: false,
      },
      {
        name: "Bathrooms",
        required: false,
        slug: "bathrooms",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "balcony",
        required: false,
        slug: "balcony",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Floor plan",
        required: false,
        slug: "floor_plan",
        type: "FILE_UPLOAD",
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    penthouse: [
      {
        name: "Bedrooms",
        required: false,
        slug: "bedrooms",
        type: "MULTI_SELECT_RANGE",
        includes: [
          "flat-apartment",
          "bunglow-villa",
          "weekend-homes",
          "penthouse",
          "farm-house",
        ],
        min: 1,
        max: 10,
        canMultiple: false,
      },
      {
        name: "Bathrooms",
        required: false,
        slug: "bathrooms",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "balcony",
        required: false,
        slug: "balcony",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Floor plan",
        required: false,
        slug: "floor_plan",
        type: "FILE_UPLOAD",
        canMultiple: true,
      },

      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    duplex: [
      {
        name: "Bedrooms",
        required: false,
        slug: "bedrooms",
        type: "MULTI_SELECT_RANGE",
        includes: [
          "flat-apartment",
          "bunglow-villa",
          "weekend-homes",
          "penthouse",
          "farm-house",
          "duplex",
        ],
        min: 1,
        max: 10,
        canMultiple: false,
      },
      {
        name: "Bathrooms",
        required: false,
        slug: "bathrooms",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "balcony",
        required: false,
        slug: "balcony",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Floor plan",
        required: false,
        slug: "floor_plan",
        type: "FILE_UPLOAD",
        canMultiple: true,
      },

      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
  },
  Commercial: {
    shop: [
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },

      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    office: [
      {
        name: "balcony",
        required: false,
        slug: "balcony",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: false,
      },
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },

      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    warehousegodown: [
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    showroom: [
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },

      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    "cold-storage": [
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    "industrial-shed": [
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    hotelresort: [
      {
        name: "balcony",
        required: false,
        slug: "balcony",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: false,
      },
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    "guest-house": [
      {
        name: "balcony",
        required: false,
        slug: "balcony",
        type: "RANGE",
        min: 0,
        max: 35,
        canMultiple: false,
      },
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    "co-working-space-business-centrespace": [
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
  },
  Plot: {
    "residential-plot": [
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    "industrial-plot": [
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
    "commercial-plot": [
      {
        name: "Car parking",
        slug: "car_parking",
        type: "RANGE",
        min: 0,
        max: 35,
      },
      {
        name: "Carpet area number",
        required: false,
        slug: "carpet_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Carpet area number",
          section_slug: "carpet_area",
        },
        canMultiple: true,
      },
      {
        name: "Carpet area type",
        required: false,
        slug: "carpet_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Carpet Area type",
          section_slug: "carpet_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Super area number",
        required: false,
        slug: "super_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Super area number",
          section_slug: "super_area",
        },
        canMultiple: true,
      },
      {
        name: "Super area type",
        required: false,
        slug: "super_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Super Area type",
          section_slug: "super_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Plot area number",
        required: false,
        slug: "plot_area_number",
        type: "METRIC_SYSTEM",
        section: {
          section_name: "Plot area number",
          section_slug: "plot_area",
        },
        canMultiple: true,
      },
      {
        name: "Plot area type",
        required: false,
        slug: "plot_area_type",
        type: "DROPDOWN",
        section: {
          section_name: "Plot Area type",
          section_slug: "plot_area",
        },
        options: areaTypes,
        canMultiple: true,
      },
      {
        name: "Expected price",
        required: false,
        slug: "asking_price",
        type: "NUMBER",
        canMultiple: true,
      },
    ],
  },
};

export const basicDetailsFieldValidations: any = {
  residential: {
    "flat-apartment": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },
      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "bunglow-villa": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },
      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: false,
      },
    ],
    "studio-apartment": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "weekend-homes": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "farm-house": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    penthouse: [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    duplex: [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },
      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    
  },
  commercial: {
    shop: [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    office: [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    warehousegodown: [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: false,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    showroom: [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "cold-storage": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: false,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "industrial-shed": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: false,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    hotelresort: [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "guest-house": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "co-working-space-business-centrespace": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
  },
  plot: {
    "residential-plot": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: false,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "industrial-plot": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: false,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "commercial-plot": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: false,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
  },
  pg: {
    pg: [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: true,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
  },
  land: {
    "agriculture-land": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: false,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "non-agriculture-land": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: false,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "commercial-land": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: false,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "industrial-land": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: false,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
    "residential-land": [
      {
        fieldName: "number",
        required: false,
      },
      {
        fieldName: "blockNo",
        required: false,
      },
      {
        fieldName: "building_name",
        required: false,
      },
      {
        fieldName: "address_line",
        required: false,
      },
      {
        fieldName: "landmark",
        required: false,
      },
      {
        fieldName: "locality",
        required: true,
      },

      {
        fieldName: "property_description",
        required: true,
      },
      {
        fieldName: "pincode",
        required: true,
      },
      {
        fieldName: "city",
        required: true,
      },
    ],
  },
};
